// Api.js
import axios from 'axios'
import axiosRetry from 'axios-retry'
import Cookies from 'js-cookie'
// Create a instance of axios to use the same base url.
const axiosAPI = axios.create({
  baseURL: process.env.API_URL,
})

const jwt = Cookies.get('jwt')

axiosAPI.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response.status == 401) {
      Cookies.remove('jwt')
      Cookies.remove('user')
      window.location.reload()
    }

    return Promise.reject(error)
  }
)

axiosRetry(axiosAPI, { retries: 3 })

// implement a method to execute all the request from here.
const apiRequest = (method, url, request) => {
  const jwt = Cookies.get('jwt')

  const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {}

  //using the axios instance to perform the request that received from each http method
  return axiosAPI({
    method,
    url,
    data: request,
    headers,
  })
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((err) => {
      console.log('An error occurred:', err.response)
      return Promise.reject(err)
    })
}

// function to execute the http get request
const get = (url, request) => apiRequest('get', url, request)

// function to execute the http delete request
const deleteRequest = (url, request) => apiRequest('delete', url, request)

// function to execute the http post request
const post = (url, request) => apiRequest('post', url, request)

// function to execute the http put request
const put = (url, request) => apiRequest('put', url, request)

// function to execute the http path request
const patch = (url, request) => apiRequest('patch', url, request)

// expose your method to other services or actions
const API = {
  get,
  delete: deleteRequest,
  post,
  put,
  patch,
}
export default API
